import { render, staticRenderFns } from "./ContractorsGeneralTab.vue?vue&type=template&id=1faaf28e&"
import script from "./ContractorsGeneralTab.vue?vue&type=script&lang=js&"
export * from "./ContractorsGeneralTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports